import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { DEFAULT_PAGE_SIZE } from "../../../utils/contants";

export const employeeApi = createApi({
    reducerPath: 'employeeApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        credentials: 'include'
    }),
    endpoints: (builder) => ({
        listEmployee: builder.mutation({
            query: (payload) => ({
                url: payload?.page ? `user?page=${payload.page}&limit=${DEFAULT_PAGE_SIZE}&search=${payload.search}&is_active=${payload.is_active}` : 'user',
                method: 'GET'
            })
        }),
        addEmployee: builder.mutation({
            query: (payload) => ({
                url: 'user',
                method: 'POST',
                body: payload
            })
        }),
        editEmployee: builder.mutation({
            query: (payload) => ({
                url: 'user',
                method: 'PATCH',
                body: payload
            })
        }),
        deleteEmployee: builder.mutation({
            query: (payload) => ({
                url: `user/${payload.id}`,
                method: 'DELETE'
            })
        }),
        countryCode: builder.mutation({
            query: () => ({
                url: 'user/country-codes',
                method: 'GET'
            })
        }),
        getEmployeeSession: builder.mutation({
            query: (payload) => ({
                url: `user/session/${payload?.id}`,
                method: 'GET'
            })
        })
    })
})

export const { useListEmployeeMutation, useAddEmployeeMutation, useEditEmployeeMutation, useDeleteEmployeeMutation, useCountryCodeMutation, useGetEmployeeSessionMutation } = employeeApi;